// @ts-nocheck 817afbc6
import _ from 'lodash';
import constants from '#packages/constants';
import * as helpIds from '#packages/helpIds';

const { ACTIONS } = constants.ROOT_COMPS.GFPP;
export const panelActions = [
  ACTIONS.SETTINGS,
  ACTIONS.BEHAVIORS,
  ACTIONS.DESIGN,
  ACTIONS.MASK,
  ACTIONS.ANIMATION,
  ACTIONS.HELP,
];
const panelMobileActions = [
  ACTIONS.SETTINGS,
  ACTIONS.MASK,
  ACTIONS.HIDE,
  ACTIONS.HELP,
  ACTIONS.ANIMATION,
];

function isTransparentVideo(editorAPI, compRef) {
  const mediaFeatures =
    editorAPI.components.design.get(compRef)?.background?.mediaRef
      ?.mediaFeatures;
  return mediaFeatures && mediaFeatures.includes('alpha');
}

export default {
  untranslatable: true,
  mainActions: [
    {
      label: 'gfpp_mainaction_MediaPlayer',
      isApplied: true,
      onClick(editorAPI, compRef) {
        const { categories } = editorAPI.mediaServices.mediaManager;
        editorAPI.panelManager.closePanelByName(
          'compPanels.panels.MediaPlayer.settingsPanel',
        );
        editorAPI.panelManager.closePanelByName(
          'compPanels.panels.MediaPlayer.maskPanel',
        );
        editorAPI.mediaServices.changeVideo(compRef, categories.VIDEO_BOX);
      },
    },
  ],
  enabledActions(editorAPI, compRef) {
    if (isTransparentVideo(editorAPI, compRef)) {
      return _.without(panelActions, ACTIONS.MASK);
    }
    return panelActions;
  },
  mobileEnabledActions(editorAPI, compRef) {
    if (isTransparentVideo(editorAPI, compRef)) {
      return _.without(panelMobileActions, ACTIONS.MASK);
    }
    return panelMobileActions;
  },
  presetActions: {
    help: {
      helpId(editorAPI, compRef) {
        const mediaFeatures =
          editorAPI.components.design.get(compRef)?.background?.mediaRef
            ?.mediaFeatures;
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line you-dont-need-lodash-underscore/includes
        const hasAlpha = _.includes(mediaFeatures, 'alpha');
        const helpId = editorAPI.isMobileEditor()
          ? helpIds.GFPP.MEDIA_PLAYER_MOBILE
          : helpIds.GFPP.MEDIA_PLAYER;
        return hasAlpha ? helpIds.GFPP.MEDIA_PLAYER_ALPHA : helpId;
      },
    },
  },
};
